var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMobileDropMenuVersion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.21 99.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Solvenox Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.17,38.55A22.14,22.14,0,0,0,36.31,60.69V16.42A22.13,22.13,0,0,0,14.17,38.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85,60.66A22.14,22.14,0,0,0,62.9,38.52V82.8A22.14,22.14,0,0,0,85,60.66Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.59,3.11H71.73a0,0,0,0,1,0,0V47.38a0,0,0,0,1,0,0H68.81A19.22,19.22,0,0,1,49.59,28.16V3.11A0,0,0,0,1,49.59,3.11Z",
    transform: "translate(85.9 -35.42) rotate(90)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.49,51.84H49.62a0,0,0,0,1,0,0V96.11a0,0,0,0,1,0,0H46.7A19.22,19.22,0,0,1,27.49,76.89V51.84A0,0,0,0,1,27.49,51.84Z",
    transform: "translate(-35.42 112.52) rotate(-90)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobileDropMenuVersion);
export default __webpack_public_path__ + "static/media/LogoMobileDropMenuVersion.0a5c6835d6cc8a3b3658d014e3a6df5e.svg";
export { ForwardRef as ReactComponent };